<template>
  <div class="mt-3 mt-lg-4 block-additional">
    <ul class="nav nav-tabs mb-3" role="tablist">
      <li v-for="t in visibleTabs" :key="t.key" class="nav-item" role="presentation">
        <button
            type="button"
            class="nav-link"
            :class="{ active: activeTab === t.key }"
            @click="changeTab(t.key)"
        >
          {{ t.label }}
        </button>
      </li>
    </ul>

    <div class="tab-content">
      <keep-alive>
        <component
            :is="currentComp"
            v-bind="childProps"
        />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import DetailedProjectCommonInfo from "@/components/common/components/DetailedProjectCommonInfo.vue";
import DetailedProjectCollaterals from "@/components/common/components/DetailedProjectCollaterals.vue";
import DetailedProjectFinancials from "@/components/common/components/DetailedProjectFinancials.vue";
import DetailedProjectDocuments from "@/components/common/components/DetailedProjectDocuments.vue";
import PaymentSchedule from "@/components/common/components/PaymentSchedule.vue";

export default {
  components: {
    DetailedProjectCommonInfo,
    DetailedProjectCollaterals,
    DetailedProjectFinancials,
    DetailedProjectDocuments,
    PaymentSchedule
  },
  props: {
    project: { type: Object, required: true },
    isFundRaising: { type: Boolean, required: true },
    secondaryMarket: { type: Boolean, required: true },
    siteUrlHost: { type: String, required: true },
    buy: { type: Boolean, default: true }
  },
  data() {
    return {
      activeTab: "common",
      tabs: [
        { key: "common", label: "Общая информация", component: "DetailedProjectCommonInfo", show: () => true },
        { key: "collaterals", label: "Обеспечение", component: "DetailedProjectCollaterals", show: () => true },
        { key: "financials", label: "Финансовая информация", component: "DetailedProjectFinancials", show: (p) => !!p.financials },
        { key: "documents", label: "Документы", component: "DetailedProjectDocuments", show: (p) => !!p.documents },
        { key: "payment-schedule", label: "График платежей", component: "PaymentSchedule", show: (p) => !!p.documents }
      ]
    };
  },
  computed: {
    visibleTabs() {
      return this.tabs.filter(t => t.show(this.project));
    },
    currentComp() {
      const tab = this.tabs.find(t => t.key === this.activeTab);
      return tab ? tab.component : "DetailedProjectCommonInfo";
    },
    childProps() {
      return {
        project: this.project,
        secondaryMarket: this.secondaryMarket,
        isFundRaising: this.isFundRaising,
        siteUrlHost: this.siteUrlHost,
        buy: this.buy,
        financials: this.project.financials,
        documents: this.project.documents,
        paymentSchedule: this.project?.loan?.paymentSchedule,
        projectStatus: this.project?.status
      };
    }
  },
  mounted() {
    const q = this.$route?.query?.tab;
    if (q && this.tabs.some(t => t.key === q)) {
      this.activeTab = q;
    } else {
      this.updateUrl("common");
    }
  },
  methods: {
    changeTab(tab) {
      if (tab === this.activeTab) return;
      this.activeTab = tab;
      this.updateUrl(tab);
    },
    updateUrl(tab) {
      const url = new URL(window.location.href);
      url.searchParams.set("tab", tab);
      window.history.replaceState({}, "", url.toString());
    }
  }
};
</script>

<style lang="scss">
.block-additional {
  min-height: 15rem;

  .h6 {
    margin-top: 1.5rem;
  }

  dl {
    dt {
      flex: 0 0 35%;
      max-width: 35%;
    }

    dd {
      flex: 0 0 60%;
      max-width: 35rem;

      a {
        float: right;
      }
    }
  }

  p {
    margin-bottom: 0.25em;
  }

  .nav-tabs {
    border: none;

    .nav-link,
    .nav-link:hover,
    .nav-link:focus,
    .nav-link.active {
      position: relative;
      border: none;
      background: none;
    }

    .nav-link {
      color: #000;
      margin-left: 0;
      margin-right: 0;

      @media (min-width: 768px) {
        margin-left: 0.25rem;
        margin-right: 0.25rem;
      }

      @media (min-width: 1040px) {
        margin-left: 0.5rem;
        margin-right: 0.5rem;
      }

      @media (min-width: 1140px) {
        margin-left: 1rem;
        margin-right: 1rem;
      }
    }

    .nav-link.active {
      color: #21e58a;
    }

    .nav-link.active:before {
      content: "";
      background: #21e58a;
      position: absolute;
      bottom: 0;
      left: 0;
      height: 0.2rem;
      width: 100%;
    }
  }
}
</style>
